export const OLYMPICS_FILTER_NS = "olympicsFilters";

export const LS_KEY_PREFIX_BY_NAMESPACE = {};
LS_KEY_PREFIX_BY_NAMESPACE[OLYMPICS_FILTER_NS] = "CBC_OLYMPICS_FILTER_";

export const AUDIENCE_TIMEOUT_MS = 10000;
